import React from 'react';
var Button = function (_a) {
    var label = _a.label;
    return (React.createElement("button", { className: 'button', type: 'button' }, label));
};
export default Button;
